import { useState } from "react";
import { createPortal } from "react-dom";
import {
  MODELS,
  MUTATIONS,
  useModel,
  useMutation,
} from "../../../../../../api";
import IconButton from "../../../../../../design-system/components/IconButton/IconButton.jsx";
import Dialog from "../../../../../../design-system/components/Dialog/Dialog.jsx";
import { getConfirmAbortButtons } from "../../../../../../design-system/components/Confirm/ConfirmAbortButtons.jsx";
import styles from "./AssignOwnershipButton.css.ts";

function AssignOwnershipButton({ user, workshop }) {
  const [open, setOpen] = useState(false);
  const me = useModel(MODELS.ME);
  const [doTransferWorkshop] = useMutation(MUTATIONS.transferWorkshopOwnership);

  if (!me) return null;

  // Only admins or workshop owners can assign ownership
  if (!me.isAdmin && workshop.owner && workshop.owner.id !== me.id) return null;

  // Owners can't transfer ownership to themselves.
  if (workshop.owner && workshop.owner.id === user.id) return null;

  function handleClick() {
    setOpen(true);
  }

  function handleConfirm() {
    setOpen(false);

    doTransferWorkshop({
      id: workshop.id,
      userId: user.id,
    });
  }

  return (
    <>
      <div className={styles.iconButton}>
        <IconButton
          name="users"
          onClick={handleClick}
          title="Verwaltung übertragen"
        />
      </div>

      {createPortal(
        <Dialog
          open={open}
          setOpen={setOpen}
          title={`Verwaltung an ${user.name} übertragen?`}
          buttons={getConfirmAbortButtons(setOpen, handleConfirm, "Übertragen")}
        >
          <p>
            Du kannst danach die Lernreise nicht mehr löschen, bist aber
            weiterhin Teil der Lernreise.
          </p>
        </Dialog>,
        document.body,
      )}
    </>
  );
}

export default AssignOwnershipButton;
